import { Listeners, ReactiveState } from './_helpers'
import { getElements, getElement } from '../utils/functional'

const classes = {
  container: 'js-MobileNav',
  items: 'js-MobileNav_Items',
  item: 'js-MobileNav_Item',
  trigger: 'js-MobileNav_Trigger',
  drawer: 'js-MobileNav_Drawer',
  back: 'js-MobileNav_Back',
}

const listeners = Object.create(Listeners)
const state = new ReactiveState({
  hasChildrenOpen: false,
})
const activeAttribute = 'data-has-child-open'

export default function init ({ el }) {

  var touchstartX = 0;
  var touchstartY = 0;
  var touchendX = 0;
  var touchendY = 0;

  var gesuredZone = el.parentElement.parentElement;
  
  gesuredZone.addEventListener('touchstart', function(event) {
      touchstartX = event.changedTouches[0].screenX;
      touchstartY = event.changedTouches[0].screenY;
  }, {passive: true});

  gesuredZone.addEventListener('touchend', function(event) {
      touchendX = event.changedTouches[0].screenX;
      touchendY = event.changedTouches[0].screenY;
      handleGesure();
  }, {passive: true}); 

  function handleGesure() {
    if (touchendX < touchstartX && (touchstartY - touchendY) < 30) {
      closeAllMobileNavDrawers()
    }
  }

  const filterLinks = getElements(`.clc-Filters_Link-filter`)

  filterLinks.forEach(filterLink => {
    filterLink.addEventListener('click', (e) => {
      e.currentTarget.classList.add('activeFilter')
    })
  })
  
  const tabButtons = getElements(`.${classes.container}_Tab`)

  tabButtons.forEach(tabButton => {
    tabButton.addEventListener('click', () => {
      if(tabButton.classList.contains('one-click')){
        window.location.href = tabButton.dataset.link
      } else {
        tabButton.classList.add('one-click')
      }
    })
  })

  listeners.add(el, 'click', handleTriggerClick)
  listeners.add(el, 'click', handleBackClick)

  window.closeAllMobileNavDrawers = () => {
    state.hasChildrenOpen = false

    const activeItems = getElements(`.${classes.item}[aria-selected='true']`)
    activeItems.forEach(el => el.setAttribute('aria-selected', 'false'))

    const overflowedDrawers = getElements(
      `.${classes.drawer}[${activeAttribute}]`
    )
    overflowedDrawers.forEach(el => el.removeAttribute(activeAttribute))
  }
}

function closeAllMobileNavDrawers(){
  state.hasChildrenOpen = false

  var activeItemElements = getElements(`.${classes.item}[aria-selected='true']`)
  activeItemElements.forEach(el => el.setAttribute('aria-selected', 'false'))

  var overflowedDrawerElements = getElements(
    `.${classes.drawer}[${activeAttribute}]`
  )
  overflowedDrawerElements.forEach(el => el.removeAttribute(activeAttribute))
  var activeMenuDrawer = getElement('.drw-Drawer-active')
  var activeBG = getElement('.drw-Drawers-active')
  activeMenuDrawer.classList.remove('drw-Drawer-active')
  activeBG.classList.remove('drw-Drawers-active')
  document.body.classList.remove('util-SiteOverflowed')

}

function handleTriggerClick ({ target }) {
  const trigger = target.closest(`.${classes.trigger}`)
  if (!trigger) return

  const parentItem = getParentItem(trigger)
  const parentDrawer = getParentDrawer(trigger)

  parentItem.setAttribute('aria-selected', 'true')

  if (parentDrawer) {
    parentDrawer.setAttribute(activeAttribute, '')
  }

  state.hasChildrenOpen = true
}

function handleBackClick ({ target }) {
  const back = target.closest(`.${classes.back}`)
  if (!back) return

  const parentItem = getParentItem(back)
  const parentDrawer = getParentDrawer(parentItem)

  parentItem.setAttribute('aria-selected', 'false')

  if (parentDrawer) {
    parentDrawer.removeAttribute(activeAttribute)
  }

  state.hasChildrenOpen = false
}

function getParentItem (el) {
  return el.closest(`.${classes.item}`)
}

function getParentDrawer (el) {
  return el.closest(`.${classes.drawer}`)
}
